import patientService from '../services/patientService';
import { setUsePatientScheduleTargetsPreference } from './patientScheduleTargetPreference';
import { remapEnrollmentSchedulePayload } from './scheduleTargetUtils';

/**
 * Apply the enrollment choice after the patient row exists.
 * Practice mode keeps readings on the live practice ranges.
 * Custom mode stores this patient's edits and switches readings to those rows.
 */
export async function applyEnrollmentScheduleChoice({
  practiceId,
  patientId,
  usePracticeSettings,
  changedPayload = null
}) {
  if (practiceId == null || patientId == null) return;

  if (usePracticeSettings) {
    setUsePatientScheduleTargetsPreference(practiceId, patientId, false);
    return;
  }

  setUsePatientScheduleTargetsPreference(practiceId, patientId, true);
  if (!changedPayload) return;

  const fresh = await patientService.getScheduleAndTargets(practiceId, patientId);
  const serverData = fresh?.data?.data || {};
  const remapped = remapEnrollmentSchedulePayload(changedPayload, serverData);
  if (!remapped) return;

  const response = await patientService.updateScheduleAndTargets(practiceId, patientId, remapped);
  if (!response?.data?.success) {
    throw new Error(response?.data?.message || 'Failed to save schedule and target settings');
  }
}
